window.addEventListener('DOMContentLoaded', function() {
 (function($) {

  var id = location.search;
  if(id != '')
  {
    id = id.replace("?id=","");  

    data = {"diamond_id": id};

    var shape ='';
    var carat ='';
    var cut = '';
    var clarity = '';
    var color = '';
    var stock = '';
    
    $.ajax({
      url: 'https://upbrighterservices.com/rapnet/get_single_diamond.php',
      type:  'POST',
      data: JSON.stringify(data),
      dataType:"json",
      success: function(data) {
        var result = data.response.body.diamond
        shape = result.shape;
        var pric = result.total_sales_price_in_currency;
        if(result.size % 1 !== 0){
            var size = result.size.toString().split('.')[1].length;
            if(size === 1){
              carat = result.size.toFixed(2);
            }else{
              carat = result.size;
            }
        }
        //carat = result.size;
        cut = result.cut;
        color = result.color;
        clarity = result.clarity;
        var has_image = result.has_image_file;
        var image_file_url = result.image_file_url;
        var video_url = result.video_url;
        var cert_num = result.cert_num;
        var report = result.lab;
        var id = result.diamond_id;
        var img = result.imagefile_url;
        var video = result.video_url;
        var flor = result.fluor_intensity;
        var dept = result.depth_percent;
        var table = result.table_percent;
        var sym = result.symmetry;
        var polis = result.polish;
        var culet = result.culet_size;
        var meas = result.meas_length +" x "+ result.meas_width +" x "+ result.meas_depth +" mm";
        stock = result.stock_num;
        price = formatter.format(pric)+" AUD";
        var title = carat+" - Carat "+shape+" Cut Diamond";
        if(cut != '')
        {
          var subtitle = cut+' Cut | '+color+' Colour | '+clarity+' Clarity';
        }
        else
        {
         var subtitle = color+' Colour | '+clarity+' Clarity';
        }
      
        var thumb = '';
        var main = '';
        // if(video != '')
        // {
        //   if(video.indexOf("V360.aspx") == -1)
        //   {
        //     thumb += "<div class='thumb-item'><iframe allowfullscreen='true' src='"+video+"'></iframe></div>";
        //     main += "<div class='main-item'><iframe allowfullscreen='true' src='"+video+"'></iframe></div>";
        //   }
          
        // }
        if(img != '')
        {
          thumb += "<div class='thumb-item'><img src='"+img+"'></div>";
          main += "<div class='main-item'><img src='"+img+"'></div>";
        }
        else
        {
          var img1 = $(".image-thumb").attr("data-img");
          img1 = img1.split("shapes.jpg");
          thumb += "<div class='thumb-item'><img src='"+img1[0]+shape.toLowerCase()+"_new.jpg'></div>";
          main += "<div class='main-item'><img src='"+img1[0]+shape.toLowerCase()+"_new.jpg'></div>";
        }
        
        if(thumb != '')
        {
          $(".image-thumb").html(thumb);
        }
        
        if(main != '')
        {
          $(".image-main").html(main);
        }

    //     if(has_image){
    //         $('.diamond-left').empty();
    //      $('.diamond-left').append(`<div class="image-thumb" data-img="`+image_file_url+`">
    //   <img src="`+image_file_url+`">
    // </div>
    // <div class="image-main" data-img="`+image_file_url+`">
    //   <div class="main-item"><img src="`+image_file_url+`"></div>
    // </div>`);
    //     }

        var html = '';

        var divhtml =`<div class="inner-row"> <dt class="column-0">
            <div class="[shape]-column-0">
              <span>[shape]</span>
              <span class="tooltip-placeholder"></span>
            </div>
          </dt>
          <dd class="column-1">
            <div class="[shape]-column-1">
              <span>[round]</span>
              <span class="tooltip-placeholder"></span>
            </div>
          </dd> </div>`;

        html += divhtml.replaceAll("[shape]","shape").replaceAll('[round]',shape);
        html += divhtml.replaceAll("[shape]","cut").replaceAll('[round]',cut);
        html += divhtml.replaceAll("[shape]","colour").replaceAll('[round]',color);
        html += divhtml.replaceAll("[shape]","clarity").replaceAll('[round]',clarity);
        html += divhtml.replaceAll("[shape]","carat").replaceAll('[round]',carat);
        html += divhtml.replaceAll("[shape]","fluorescence").replaceAll('[round]',flor);
        html += divhtml.replaceAll("[shape]","depth").replaceAll('[round]',dept);
        html += divhtml.replaceAll("[shape]","table").replaceAll('[round]',table);
        html += divhtml.replaceAll("[shape]","polish").replaceAll('[round]',polis);
        html += divhtml.replaceAll("[shape]","symmetry").replaceAll('[round]',sym);
        html += divhtml.replaceAll("[shape]","culet").replaceAll('[round]',culet);
        html += divhtml.replaceAll("[shape]","measurements").replaceAll('[round]',meas);
        html += divhtml.replaceAll("[shape]","Stock Number").replaceAll('[round]',stock);

        $(".diamond-heading").html(title);
        $(".diamond-subheading").html(subtitle);
        $(".diamond-price").html(price);
        $(".details-table .row").html(html);
        $(".loader-wrapper").hide();
        $(".detail-section").show();
        $(".view_report").attr('href', 'https://upbrighterservices.com/rapnet/report.php?report_no='+cert_num);
      }
    });

    $(".diamond-atc").on("click",function(e){
        $(this).addClass("disabled");
        var title = $(".diamond-heading").text();
        var img = "https:"+$(".main-item img").attr("src");
        var price = $(".diamond-price").text();
        price = price.replace("$","").replaceAll(",","").replace("AUD","");
        var sku = $(".Stock.Number-column-1 span:first-child").text();
        var body = $(".diamond-subheading").text();

       
        var data = {
                     "title" : title,
                     "bodyHtml" : body,
                     "image_src" : img,
                     "sku" : sku,
                     "price" : price
                    };
        if(cut != '')
        {
         var prop = "&properties[Shape]="+shape+"&properties[Cut]="+cut+"&properties[Carat]="+carat+"&properties[Clarity]="+clarity+"&properties[Color]="+color+"&properties[Stock Number]="+stock;
        }
        else
        {
          var prop = "&properties[Shape]="+shape+"&properties[Carat]="+carat+"&properties[Clarity]="+clarity+"&properties[Color]="+color+"&properties[Stock Number]="+stock;
        }
      
        $.ajax({
          url: 'https://upbrighterservices.com/rapnet/create_product.php',
          type:  'POST',
          data: JSON.stringify(data),
          dataType:"json",
          success: function(data) {
            var id = data.variant_id;
            $.ajax({
              url: '/cart/add.js',
              type:  'POST',
              data: 'quantity=1&id='+id+prop,
              dataType:"json",
              success: function(data) {
                window.location = "/cart";
              }
            })
          }
        });
        
      });
    
  }
  else
  {
    window.location = "/pages/diamond-search"
  }

function addDays(n){
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Sataturday"];

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    var t = new Date();
    t.setDate(t.getDate() + n); 
    var day = days[t.getDay()];
    var month = months[t.getMonth()];
    var date = "0"+t.getDate();
    date = date.slice(-2);
    var final = date +"/"+month +"/"+t.getFullYear();
    return day+", "+month+" "+date;
}

function time(){
      var d = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      var m = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
      var now = new Date().getTime();
      var nextDay = new Date();
      nextDay.setDate(nextDay.getDate() + 1);
  
      var nextDate = d[nextDay.getDay()]+" "+m[nextDay.getMonth()]+" "+nextDay.getDate()+" "+nextDay.getFullYear();
  
      date = new Date(nextDate+" 00:00:00").getTime();
  
      var distance = date - now;
  
      // Time calculations for days, hours, minutes and seconds
      var days1 = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      return hours + " hours "+ minutes + " minutes";
}   
   

// document.getElementById("ship1").innerHTML = addDays(9);
// document.getElementById("ship2").innerHTML = addDays(12);  

// document.getElementById("hours").innerHTML = time();  

   
  var formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  });  

  $(".expandable-widget").on("click",function(){
    $(this).toggleClass("open");
  }); 

   
 })($);
});